import { LinkId } from '../../../AnalyticsContext/LinkId';
import { useMobile } from '../../../services/screenSize/ScreenSizeService';
import { ButtonVariants } from '../../Button/DeprecatedButtonVariants';
import {
  Buttons,
  HeyKid,
  HeyKidB,
  PracticeSectionView,
  BannerLinkButton,
} from './PracticeSection.styles';

export const PracticeSection = () => (
  <PracticeSectionView>
    <HeyKid>
      <HeyKidB>Are you a healthcare provider?</HeyKidB> Get listed on Healthengine for free!
    </HeyKid>
    <Buttons>
      <BannerLinkButton
        to="https://practices.healthengine.com.au/list-your-practice/?pracsource=header-link"
        trackingId={LinkId.FOOTER_PRACTICE_DISCOVER_MORE}
        variant={ButtonVariants.primary}
        options={{ small: useMobile() }}
      >
        List your practice
      </BannerLinkButton>
    </Buttons>
  </PracticeSectionView>
);
